import React, { Component } from 'react';
import PropTypes from 'prop-types';

import merge from 'lodash/merge';

import TextInput from 'forms/TextInput';
import StripeInput from 'forms/StripeInput';

import { injectStripe } from 'react-stripe-elements';

class CreditCardForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      cardReady: false,
      elementsReady: []
    }
  }

  elementChange = (elementName, status) => {
    const newState = merge({}, this.state);

    if (status.complete) {
      if (newState.elementsReady.indexOf(elementName) == -1) newState.elementsReady.push(elementName);
      newState.cardReady = newState.elementsReady.length >= 3;
      this.setState(newState);
    }

    this.props.setStripe(newState.cardReady ? this.props.stripe : null);
  }

  globalCardError() {
    if (this.props.formApi.submits == 0 || this.props.tokenReceived || this.props.formApi.errors || this.state.cardReady) return null;

    return (
      <p className="input-error StripeElement-error">{App.t('order.card_missing')}</p>
    )
  }

  render() {
    const stripeFieldOptions = {
      onChange: this.elementChange,
      formApi:  this.props.formApi,
    };

    return (
      <div>
        <div className="form-fieldLine">
          <StripeInput type="cardNumber" label={App.t('order.card_number')} {...stripeFieldOptions} />
          <StripeInput type="cardExpiry" label={App.t('order.card_date')} {...stripeFieldOptions} />
          <StripeInput type="cardCvc" label={App.t('order.card_code')} {...stripeFieldOptions} />
        </div>
        {this.globalCardError()}
      </div>
    );
  }

}

CreditCardForm.propTypes = {
  setStripe:      PropTypes.func.isRequired,
  formApi:        PropTypes.object.isRequired,
  tokenReceived:  PropTypes.bool.isRequired,
};

export default injectStripe(CreditCardForm);
